import { DynamicFormControlCustomEvent } from '@ng-dynamic-forms/core';
import { CustomEventDetailMap } from '../dynamic-form-components/shared-models/custom-events.model';

export type KnownCustomEventType = keyof CustomEventDetailMap;

/**
 * @see `/src/app/helpers/custom-event.helper.ts`
 */

/**
 * Create a type-safe custom event, checked against a global map of available event type names & typed payloads.
 */
export function strictCustomEvent<T extends KnownCustomEventType, D extends CustomEventDetailMap[T]>(
  customEventType: T,
  customEventInit: CustomEventInit<D> & { detail: D }
): CustomEvent<D> {
  return new CustomEvent(customEventType, customEventInit);
}

/**
 * Create a type-safe custom event, checked against a global map of available event type names & typed payloads
 * for use with @see{CustomDynamicFormControlComponent}s' `customEvent` Emitter.
 */
export function strictDynamicFormControlCustomEvent<T extends KnownCustomEventType, D extends CustomEventDetailMap[T]>(
  customEventType: T,
  customEventInit: CustomEventInit<D> & { detail: D }
): DynamicFormControlCustomEvent & { customEvent: CustomEvent<D> } {
  return {
    customEvent: strictCustomEvent(customEventType, customEventInit),
    customEventType
  };
}
